import { useSnackbar } from 'lib/snackbar';
import { useUnsavedChangesContext } from "ui/widgets/UnsavedChanges";
import useActions from "./useActions";

export const useLogout = () => {
    const { logout } = useActions();
    const { enqueueSnackbar } = useSnackbar();
    const { checkUnsavedChanges } = useUnsavedChangesContext();

    return () => (
        checkUnsavedChanges({
            onCancel: () => Promise.reject()
        })
        .then(() => {
            try {
                const [request] = logout();
                return request;
            } catch (error) {
                console.error(error);
                enqueueSnackbar('Unable to logout!', { variant: 'error' });

                return Promise.reject(error);
            }
        })
    );
};

export default useLogout;
